// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-notifications-count{position:absolute;top:-3px;display:inline-block;color:#fff;background-color:#ff5a00;font-size:9px;border-radius:8px;padding:1px 6px;width:-moz-fit-content;width:fit-content;right:-8px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
